import VisitePage from "./VisitePage";

// ═══════════════════════════════════════════
// REIMS & CHAMPAGNE
// ═══════════════════════════════════════════
export const VisiteReimsPage = () => (
  <VisitePage config={{
    slug: "reims-champagne",
    title: "Journée Visite Reims & Champagne avec Chauffeur Privé | ALTURA",
    h1: "Journée Reims & Champagne",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.pexels.com/photos/13598485/pexels-photo-13598485.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    distance: "~145 km depuis Paris",
    duration: "Journée complète (8-10h)",
    intro: "Partez à la découverte de Reims et de la route du Champagne avec votre chauffeur privé ALTURA. Visitez la majestueuse cathédrale Notre-Dame de Reims, où étaient couronnés les rois de France, puis explorez les prestigieuses maisons de Champagne : Veuve Clicquot, Taittinger, Ruinart ou Moët & Chandon à Épernay. Votre chauffeur vous conduit de cave en cave, vous laissant profiter des dégustations en toute sérénité. Une journée inoubliable entre histoire, gastronomie et bulles de prestige.",
    highlights: [
      "Cathédrale Notre-Dame de Reims (UNESCO)",
      "Caves de Champagne (Veuve Clicquot, Taittinger, Ruinart)",
      "Avenue de Champagne à Épernay",
      "Palais du Tau — trésor des sacres royaux",
      "Vignobles de la Montagne de Reims",
      "Déjeuner dans un restaurant étoilé (sur demande)",
    ],
    sections: [
      {
        title: "Programme type de la journée",
        content: "Votre chauffeur vous prend en charge le matin à votre hôtel ou domicile parisien. Direction Reims par l'autoroute A4 (environ 1h30 de trajet). La journée s'organise selon vos envies :",
        list: [
          "9h00 — Départ de Paris, trajet confortable vers Reims",
          "10h30 — Visite de la Cathédrale de Reims et du centre historique",
          "12h30 — Déjeuner dans un restaurant de la région",
          "14h30 — Visite et dégustation dans une grande maison de Champagne",
          "16h00 — Route vers Épernay et l'Avenue de Champagne",
          "17h00 — Seconde dégustation ou balade dans les vignobles",
          "18h30 — Retour vers Paris, arrivée estimée vers 20h",
        ],
      },
      {
        title: "Pourquoi choisir un chauffeur privé ?",
        content: "La route du Champagne implique des dégustations. Avec un chauffeur ALTURA, profitez de chaque verre en toute tranquillité. Pas de souci de conduite, pas de limitation : savourez pleinement l'expérience. Votre chauffeur connaît les meilleures adresses et peut adapter le programme en temps réel selon vos coups de cœur.",
      },
    ],
    faq: [
      { q: "Combien coûte une journée Reims & Champagne avec chauffeur ?", a: "Le tarif dépend du véhicule choisi et de la durée. Contactez-nous par WhatsApp ou téléphone pour un devis personnalisé en fonction de vos envies." },
      { q: "Faut-il réserver les visites de caves à l'avance ?", a: "Oui, nous recommandons de réserver les dégustations 1 à 2 semaines à l'avance. Nous pouvons vous aider dans l'organisation." },
      { q: "Combien de temps dure le trajet Paris-Reims ?", a: "Environ 1h30 par l'autoroute A4. Le trajet est confortable et rapide dans nos véhicules Mercedes." },
    ],
  }} />
);

// ═══════════════════════════════════════════
// GIVERNY & MONET
// ═══════════════════════════════════════════
export const VisiteGivernyPage = () => (
  <VisitePage config={{
    slug: "giverny-monet",
    title: "Visite Giverny Jardins de Monet avec Chauffeur Privé | ALTURA",
    h1: "Jardins de Monet à Giverny",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.unsplash.com/photo-1656719529536-a7579c2778a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxHaXZlcm55JTIwTW9uZXQlMjBnYXJkZW4lMjB3YXRlciUyMGxpbGllcyUyMGJyaWRnZXxlbnwwfHx8fDE3NzcwNzA1NjR8MA&ixlib=rb-4.1.0&q=85",
    distance: "~75 km depuis Paris",
    duration: "Demi-journée ou journée (4-8h)",
    intro: "Plongez dans l'univers impressionniste de Claude Monet en visitant sa maison et ses jardins à Giverny. Le célèbre pont japonais, les nymphéas, le clos normand fleuri... Chaque saison offre un spectacle différent. Votre chauffeur ALTURA vous conduit directement depuis Paris dans le confort d'une Mercedes, vous évitant les contraintes du transport en commun. Idéal pour les amateurs d'art, les couples et les visiteurs internationaux.",
    highlights: [
      "Maison de Claude Monet",
      "Jardin d'eau — nymphéas et pont japonais",
      "Clos normand — jardin fleuri",
      "Musée des Impressionnismes de Giverny",
      "Village pittoresque de Giverny",
      "Église Sainte-Radegonde (tombe de Monet)",
    ],
    sections: [
      {
        title: "Programme type",
        content: "Giverny se prête aussi bien à une demi-journée qu'à une journée complète combinée avec d'autres visites en Normandie.",
        list: [
          "9h00 — Départ de Paris, trajet vers Giverny (~1h15)",
          "10h15 — Visite de la Maison et des Jardins de Monet",
          "12h30 — Déjeuner au village de Giverny",
          "14h00 — Musée des Impressionnismes ou promenade",
          "15h30 — Retour vers Paris (arrivée ~17h)",
        ],
      },
      {
        title: "Conseils pratiques",
        content: "Les jardins de Monet sont ouverts d'avril à novembre. La meilleure période pour voir les nymphéas en fleur est de juin à août. Nous recommandons une visite le matin pour éviter l'affluence. Votre chauffeur vous dépose directement à l'entrée et vous attend pour le retour.",
      },
    ],
    faq: [
      { q: "Quand visiter Giverny ?", a: "Les jardins sont ouverts d'avril à novembre. La meilleure période est de mai à juillet pour les floraisons. Juin est idéal pour les nymphéas." },
      { q: "Peut-on combiner Giverny avec une autre visite ?", a: "Oui, en journée complète vous pouvez combiner avec Rouen, les falaises d'Étretat ou le château de La Roche-Guyon." },
    ],
  }} />
);

// ═══════════════════════════════════════════
// CHÂTEAUX DE LA LOIRE
// ═══════════════════════════════════════════
export const VisiteLoirePage = () => (
  <VisitePage config={{
    slug: "chateaux-loire",
    title: "Visite Châteaux de la Loire avec Chauffeur Privé | ALTURA",
    h1: "Châteaux de la Loire",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.unsplash.com/photo-1763828483140-1956a82a530e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxMb2lyZSUyMFZhbGxleSUyMGNoYXRlYXUlMjBDaGFtYm9yZCUyMGNhc3RsZSUyMEZyYW5jZXxlbnwwfHx8fDE3NzcwNzA1NjZ8MA&ixlib=rb-4.1.0&q=85",
    distance: "~190 km depuis Paris",
    duration: "Journée complète (10-12h)",
    intro: "Explorez les joyaux de la Renaissance française avec votre chauffeur privé ALTURA. Le Val de Loire, classé au patrimoine mondial de l'UNESCO, abrite les plus beaux châteaux de France : Chambord, Chenonceau, Amboise, Cheverny... Une journée ne suffit pas pour tout voir, mais votre chauffeur optimise l'itinéraire pour vous offrir le meilleur de la Loire. Paysages sublimes, architecture grandiose et gastronomie locale au programme.",
    highlights: [
      "Château de Chambord — chef-d'œuvre de la Renaissance",
      "Château de Chenonceau — le château des Dames",
      "Château d'Amboise — dernière demeure de Léonard de Vinci",
      "Clos Lucé — maison de Léonard de Vinci",
      "Château de Cheverny — inspiration de Moulinsart (Tintin)",
      "Dégustation de vins de Loire (Vouvray, Chinon, Sancerre)",
    ],
    sections: [
      {
        title: "Programme type — 2 ou 3 châteaux",
        content: "Nous recommandons de visiter 2 à 3 châteaux dans la journée pour profiter de chaque site sans se presser.",
        list: [
          "7h30 — Départ de Paris, direction le Val de Loire (~2h)",
          "9h30 — Visite du Château de Chambord",
          "12h00 — Déjeuner dans une auberge locale",
          "14h00 — Visite du Château de Chenonceau",
          "16h30 — Visite du Château d'Amboise ou du Clos Lucé",
          "18h00 — Retour vers Paris (arrivée ~20h)",
        ],
      },
      {
        title: "L'avantage du chauffeur privé",
        content: "Les châteaux de la Loire sont dispersés sur un vaste territoire. Sans voiture, les visiter est quasi impossible. Avec ALTURA, votre chauffeur organise les trajets entre chaque château, vous évitant les parkings bondés et les routes inconnues. Détendez-vous et profitez des paysages ligériens depuis votre véhicule.",
      },
    ],
    faq: [
      { q: "Combien de châteaux peut-on visiter en une journée ?", a: "Nous recommandons 2 à 3 châteaux pour une journée agréable sans se presser. Chambord + Chenonceau est la combinaison la plus populaire." },
      { q: "Le trajet est-il long depuis Paris ?", a: "Environ 2h jusqu'au premier château (Chambord). Le trajet passe par l'autoroute A10, très confortable dans nos Mercedes." },
    ],
  }} />
);

// ═══════════════════════════════════════════
// PLAGES DU DÉBARQUEMENT — NORMANDIE
// ═══════════════════════════════════════════
export const VisiteNormandiePage = () => (
  <VisitePage config={{
    slug: "plages-debarquement-normandie",
    title: "Visite Plages du Débarquement Normandie avec Chauffeur | ALTURA",
    h1: "Plages du Débarquement — Normandie",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.pexels.com/photos/17892502/pexels-photo-17892502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    distance: "~280 km depuis Paris",
    duration: "Journée complète (12-14h)",
    intro: "Revivez l'histoire du Débarquement du 6 juin 1944 avec votre chauffeur privé ALTURA. Visitez les plages mythiques d'Omaha Beach, le cimetière américain de Colleville-sur-Mer, la Pointe du Hoc et le musée du Débarquement. Un voyage chargé d'émotion à travers les sites les plus marquants de la Seconde Guerre mondiale en Normandie. Votre chauffeur vous accompagne toute la journée pour un parcours mémoriel complet et respectueux.",
    highlights: [
      "Omaha Beach — la plage la plus emblématique du D-Day",
      "Cimetière américain de Colleville-sur-Mer",
      "Pointe du Hoc — site des Rangers américains",
      "Musée du Débarquement (Arromanches ou Utah Beach)",
      "Sainte-Mère-Église — premier village libéré",
      "Batteries de Longues-sur-Mer",
    ],
    sections: [
      {
        title: "Programme type de la journée",
        content: "Une journée complète est nécessaire pour rendre hommage à ces lieux de mémoire. Votre chauffeur ALTURA vous propose un itinéraire optimisé :",
        list: [
          "7h00 — Départ de Paris, direction la Normandie (~3h)",
          "10h00 — Arrivée à la Pointe du Hoc",
          "11h30 — Cimetière américain de Colleville-sur-Mer",
          "13h00 — Déjeuner dans un restaurant normand",
          "14h30 — Omaha Beach et monument Les Braves",
          "16h00 — Musée du Débarquement à Arromanches",
          "17h30 — Retour vers Paris (arrivée ~20h30)",
        ],
      },
      {
        title: "Un devoir de mémoire",
        content: "Les plages du Débarquement sont un lieu de recueillement et de mémoire. Votre chauffeur ALTURA assure un transport respectueux et confortable pour cette journée chargée d'émotion. Idéal pour les familles, les vétérans et leurs descendants, ou tout visiteur souhaitant comprendre ce chapitre décisif de l'Histoire.",
      },
    ],
    faq: [
      { q: "Combien de temps faut-il pour visiter les plages du Débarquement ?", a: "Une journée complète est recommandée (12-14h avec les trajets). Comptez 6 à 7 heures sur place pour visiter les principaux sites." },
      { q: "Peut-on prendre un guide sur place ?", a: "Oui, nous pouvons organiser la réservation d'un guide local spécialisé dans l'histoire du D-Day pour enrichir votre visite." },
    ],
  }} />
);

// ═══════════════════════════════════════════
// BRUGES — BELGIQUE
// ═══════════════════════════════════════════
export const VisiteBrugesPage = () => (
  <VisitePage config={{
    slug: "bruges-belgique",
    title: "Journée Visite Bruges Belgique avec Chauffeur Privé | ALTURA",
    h1: "Bruges — La Venise du Nord",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.unsplash.com/photo-1759338045500-0a219299c612?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxCcnVnZXMlMjBCZWxnaXVtJTIwY2FuYWxzJTIwbWVkaWV2YWwlMjBvbGQlMjB0b3dufGVufDB8fHx8MTc3NzA3MDU3M3ww&ixlib=rb-4.1.0&q=85",
    distance: "~310 km depuis Paris",
    duration: "Journée complète (12-14h)",
    intro: "Découvrez Bruges, joyau médiéval de la Belgique, avec votre chauffeur privé ALTURA. Surnommée « la Venise du Nord » pour ses canaux pittoresques, Bruges est un enchantement à chaque coin de rue : beffroi imposant, marché couvert, dentellières, chocolateries artisanales et brasseries traditionnelles. Votre chauffeur vous conduit confortablement depuis Paris et vous attend pendant que vous explorez cette ville magique inscrite au patrimoine mondial de l'UNESCO.",
    highlights: [
      "Grand-Place de Bruges (Markt) et Beffroi",
      "Canaux et promenade en bateau",
      "Basilique du Saint-Sang",
      "Musée Groeninge — art flamand",
      "Béguinage et Lac d'Amour (Minnewater)",
      "Chocolateries et brasseries artisanales",
    ],
    sections: [
      {
        title: "Programme type de la journée",
        content: "Bruges se découvre idéalement en une journée. La ville est compacte et se visite facilement à pied.",
        list: [
          "7h30 — Départ de Paris, direction Bruges (~3h)",
          "10h30 — Arrivée à Bruges, dépose au centre",
          "10h45 — Grand-Place, Beffroi, Basilique du Saint-Sang",
          "12h30 — Déjeuner : moules-frites ou cuisine flamande",
          "14h00 — Promenade en bateau sur les canaux",
          "15h00 — Béguinage, Lac d'Amour, chocolateries",
          "17h00 — Temps libre pour le shopping",
          "18h00 — Retour vers Paris (arrivée ~21h)",
        ],
      },
      {
        title: "Pourquoi Bruges avec ALTURA ?",
        content: "Le train Paris-Bruges nécessite un changement à Bruxelles et prend plus de 3h. Avec votre chauffeur ALTURA, le trajet est direct, confortable et flexible. Vous partez et revenez à l'heure qui vous convient, sans contrainte de train. Et si vous voulez faire un arrêt à Gand ou Bruxelles sur le retour, c'est possible !",
      },
    ],
    faq: [
      { q: "Combien de temps dure le trajet Paris-Bruges ?", a: "Environ 3 heures par l'autoroute. Le trajet est confortable et direct dans nos Mercedes, contrairement au train qui nécessite un changement." },
      { q: "Peut-on combiner Bruges avec Gand ou Bruxelles ?", a: "Oui ! Sur le trajet retour, nous pouvons nous arrêter à Gand (30 min de Bruges) ou Bruxelles (1h de Bruges) pour quelques heures." },
    ],
  }} />
);

// ═══════════════════════════════════════════
// CHÂTEAU DE VERSAILLES
// ═══════════════════════════════════════════
export const VisiteVersaillesPage = () => (
  <VisitePage config={{
    slug: "chateau-versailles",
    title: "Visite Château de Versailles Journée avec Chauffeur Privé | ALTURA",
    h1: "Journée au Château de Versailles",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.pexels.com/photos/13987557/pexels-photo-13987557.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    distance: "~20 km depuis Paris",
    duration: "Demi-journée ou journée (4-8h)",
    intro: "Offrez-vous une journée royale au Château de Versailles avec votre chauffeur privé ALTURA. Explorez la Galerie des Glaces, les Grands Appartements, le domaine de Marie-Antoinette et les jardins à la française dessinés par Le Nôtre. Votre chauffeur vous dépose à l'entrée, vous attend pendant la visite et vous ramène quand vous le souhaitez. L'alternative la plus confortable et élégante au RER bondé.",
    highlights: [
      "Galerie des Glaces et Grands Appartements",
      "Jardins à la française de Le Nôtre",
      "Grand et Petit Trianon",
      "Domaine de Marie-Antoinette",
      "Spectacle des Grandes Eaux (en saison)",
      "Orangerie et pièces d'eau",
    ],
    sections: [
      {
        title: "Programme type",
        content: "Versailles mérite une demi-journée minimum, une journée complète pour tout voir :",
        list: [
          "9h00 — Départ de Paris, arrivée à Versailles en 30-40 min",
          "9h40 — Entrée au Château (éviter l'affluence du matin)",
          "12h00 — Déjeuner au domaine ou restaurant à Versailles",
          "13h30 — Jardins, Grand Trianon, Hameau de la Reine",
          "16h00 — Temps libre ou boutiques",
          "17h00 — Retour vers Paris",
        ],
      },
      {
        title: "Le confort ALTURA vs le RER",
        content: "Le RER C met environ 1h depuis Paris centre, souvent bondé et inconfortable. Avec ALTURA, vous êtes à Versailles en 30 minutes dans le confort d'une Mercedes, déposé directement à l'entrée du Château. Pas de correspondances, pas de marche, pas de stress.",
      },
    ],
    faq: [
      { q: "Versailles en demi-journée ou journée complète ?", a: "Le Château seul se visite en 2-3h. Avec les jardins, le Trianon et le domaine de Marie-Antoinette, comptez une journée complète." },
      { q: "Les Grandes Eaux, c'est quoi ?", a: "Un spectacle de fontaines dans les jardins, accompagné de musique baroque. Disponible les week-ends d'avril à octobre. Un moment magique à ne pas manquer." },
    ],
  }} />
);

// ═══════════════════════════════════════════
// FONTAINEBLEAU
// ═══════════════════════════════════════════
export const VisiteFontainebleauPage = () => (
  <VisitePage config={{
    slug: "fontainebleau",
    title: "Visite Château de Fontainebleau avec Chauffeur Privé | ALTURA",
    h1: "Château de Fontainebleau",
    subtitle: "ALTURA · Visites avec chauffeur",
    heroImage: "https://images.unsplash.com/photo-1597048534858-e4e6bd49a3ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxGb250YWluZWJsZWF1JTIwY2FzdGxlJTIwcGFsYWNlJTIwRnJhbmNlJTIwZ2FyZGVuc3xlbnwwfHx8fDE3NzcwNzA1NzR8MA&ixlib=rb-4.1.0&q=85",
    distance: "~70 km depuis Paris",
    duration: "Demi-journée ou journée (4-8h)",
    intro: "Explorez le Château de Fontainebleau, résidence des souverains français pendant huit siècles, de Louis VII à Napoléon III. Moins fréquenté que Versailles mais tout aussi majestueux, Fontainebleau offre une expérience intime et authentique. Ses 1 500 pièces, ses jardins à l'anglaise et sa forêt environnante en font une excursion parfaite depuis Paris. Votre chauffeur ALTURA vous y conduit en toute élégance.",
    highlights: [
      "Grands Appartements — salle du Trône de Napoléon",
      "Galerie François Ier — chef-d'œuvre de la Renaissance",
      "Chapelle de la Trinité",
      "Jardins à l'anglaise et étang des Carpes",
      "Cour des Adieux (adieux de Napoléon)",
      "Forêt de Fontainebleau — randonnée et escalade",
    ],
    sections: [
      {
        title: "Programme type",
        content: "Fontainebleau se combine parfaitement avec le village de Barbizon (berceau de l'impressionnisme) ou la forêt pour une journée complète.",
        list: [
          "9h30 — Départ de Paris (~1h de trajet)",
          "10h30 — Visite du Château et des Grands Appartements",
          "12h30 — Déjeuner à Fontainebleau ou Barbizon",
          "14h00 — Jardins du château ou promenade en forêt",
          "16h00 — Retour vers Paris (arrivée ~17h)",
        ],
      },
      {
        title: "Fontainebleau vs Versailles",
        content: "Fontainebleau est plus intime, moins touristique et offre une plongée unique dans 800 ans d'histoire de France. Si vous avez déjà visité Versailles, Fontainebleau est le complément parfait. La forêt environnante ajoute une dimension nature que Versailles n'offre pas.",
      },
    ],
    faq: [
      { q: "Fontainebleau ou Versailles ?", a: "Les deux sont exceptionnels. Versailles est plus grandiose et iconique. Fontainebleau est plus intime, avec 800 ans d'histoire. Si vous avez le temps, faites les deux sur deux journées différentes." },
      { q: "Peut-on se promener en forêt de Fontainebleau ?", a: "Oui ! La forêt de Fontainebleau est idéale pour une promenade. Votre chauffeur peut vous déposer à un point de départ de randonnée et vous récupérer à l'arrivée." },
    ],
  }} />
);
